routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.orders', {
      url: __env.routes.orders,
      template: `<orders sh-ctrl="shCtrl"></orders>`
    });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/orders/orders.config.js